import { NavigationDropdown } from "@components/general/NavigationDropdown/NavigationDropdown";
import { FC } from "react";
import styles from "@general/NavigationDropdown/NavigationDropdown.module.scss";
import classNames from "classnames";
import { useUser } from "@hooks/useUser";
import { WorkspaceSwitcherItem } from "@components/general/NavigationDropdown/WorkspaceSwitcherItem";
import { PersonalViewNavigationDropdownToggle } from "./PersonalViewNavigationDropdownToggle";

export const PersonalViewNavigationDropdown: FC = () => {
    const user = useUser();
    return (
        <NavigationDropdown
            toggle={PersonalViewNavigationDropdownToggle}
            header={
                <div
                    className={classNames(
                        styles.navigationDropdownItemTextOnly,
                        styles.navigationDropdownUserEmail,
                    )}
                    data-testid="user-email"
                >
                    {user.email}
                </div>
            }
        >
            <WorkspaceSwitcherItem />
        </NavigationDropdown>
    );
};
